module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.6011f2e2.webp";